// extracted by mini-css-extract-plugin
module.exports = {"audioRecorder":"AudioRecorder_audioRecorder__19rff","soundBtn":"AudioRecorder_soundBtn__2MaJy"};